module.exports = __webpack_public_path__ + "static/media/icon-arrow-btn.032fad1c.svg";